export default "data:application/octet-stream;base64,W1pvbmVUcmFuc2Zlcl0KWm9uZUlkPTMKSG9zdFVybD1odHRwczovL2xhbmh1YXBwLmNvbS8K"